import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Auth.css";

function ChangePassword() {
  const [step, setStep] = useState(1); // Step 1: Email, Step 2: New Password
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  // Step 1: Check if current password is correct
  const handleVerifyPassword = async (e) => {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);

    const savedUser = localStorage.getItem("user");

    const passwordId = { currentPassword, savedUser };

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/verify-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(passwordId),
        },
      );

      const data = await res.json();

      if (!res.ok) throw new Error(data.error || "Verification failed");

      setStep(2); // Proceed to password input step
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Step 2: Reset password directly
  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);

    const savedUser = localStorage.getItem("user");

    const passwordId = { password, savedUser };

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/change-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(passwordId),
        },
      );
      const data = await res.json();

      if (!res.ok) throw new Error(data.error || "Password update failed");

      alert(data.message);
      navigate("/");
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <h1 className="auth-title">
            {step === 1 ? "Change Password" : "New Password"}
          </h1>
          <p className="auth-subtitle">
            {step === 1
              ? "Enter your current password to continue."
              : `Enter a new password`}
          </p>
        </div>

        {error && <div className="auth-error">{error}</div>}

        {step === 1 ? (
          <form onSubmit={handleVerifyPassword} className="auth-form">
            <div className="form-group">
              <label className="form-label" htmlFor="currentPasword">
                Current Password
              </label>
              <input
                id="currentPasword"
                type="password"
                className="form-input"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="auth-submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Checking..." : "Verify Password"}
            </button>
          </form>
        ) : (
          <form onSubmit={handleChangePassword} className="auth-form">
            <div className="form-group">
              <label className="form-label" htmlFor="password">
                New Password
              </label>
              <input
                id="password"
                type="password"
                className="form-input"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="auth-submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Updating..." : "Update Password"}
            </button>
          </form>
        )}

        <hr className="auth-divider" />
      </div>
    </div>
  );
}

export default ChangePassword;
